/**
 * COMMERCE-FISCAL-161A-R1 — Engagement Hub infrastructure only.
 * Games / stickers / heroes / worlds are NOT implemented.
 * Production flag must remain false.
 */

export type EngagementHubEntryId = "games" | "stickers" | "heroes" | "worlds";

export type EngagementHubContract = {
  enabled: boolean;
  staging_preview: boolean;
  title_uk: string;
  title_en: string;
  entries: Array<{
    id: EngagementHubEntryId;
    label_uk: string;
    label_en: string;
    icon: string;
    status: "coming_soon";
  }>;
};

/** Vite: set VITE_ENGAGEMENT_HUB_STAGING_PREVIEW=true only for staging preview builds. */
export function isEngagementHubStagingPreviewEnabled(): boolean {
  try {
    const raw = String(
      (import.meta as unknown as { env?: Record<string, string> }).env
        ?.VITE_ENGAGEMENT_HUB_STAGING_PREVIEW ?? "",
    )
      .trim()
      .toLowerCase();
    return raw === "true" || raw === "1";
  } catch {
    return false;
  }
}

/** Production master flag — always false in this task. */
export const ENGAGEMENT_HUB_PRODUCTION_ENABLED = false;

export function resolveEngagementHubContract(): EngagementHubContract {
  const stagingPreview = isEngagementHubStagingPreviewEnabled();
  const enabled = ENGAGEMENT_HUB_PRODUCTION_ENABLED || stagingPreview;
  return {
    enabled,
    staging_preview: stagingPreview,
    title_uk: "Мої пригоди",
    title_en: "My adventures",
    entries: [
      { id: "games", label_uk: "Ігри", label_en: "Games", icon: "🎮", status: "coming_soon" },
      {
        id: "stickers",
        label_uk: "Стікери",
        label_en: "Stickers",
        icon: "🧩",
        status: "coming_soon",
      },
      { id: "heroes", label_uk: "Герої", label_en: "Heroes", icon: "🐉", status: "coming_soon" },
      { id: "worlds", label_uk: "Світи", label_en: "Worlds", icon: "🌏", status: "coming_soon" },
    ],
  };
}
